import { Flex } from '@chakra-ui/react';

import { DialogContextProvider, GenericDialog } from '@components/common/GenericDialog';
import NavigationSidebar from '@features/navigation/NavigationSidebar';

const PAGE_CONTENT_BORDER_RADIUS = '6px';

const GlobalNavigationMenu = ({ children }: { children: React.ReactNode }) => {
  return (
    <DialogContextProvider>
      <Flex
        height="100dvh"
        background="sidebar.background"
        overflow="hidden"
        flexDirection="column"
        id="navigation-container"
        paddingX="6px"
        paddingY="6px"
      >
        <Flex flexDirection="row" height="100%">
          <Flex height="100%" hideBelow="lg">
            <NavigationSidebar />
          </Flex>
          <Flex
            height="full"
            flex="1 1 0"
            minW={0}
            backgroundColor="surface.background"
            borderRadius={PAGE_CONTENT_BORDER_RADIUS}
          >
            {children}
          </Flex>
        </Flex>
        <GenericDialog />
      </Flex>
    </DialogContextProvider>
  );
};

export default GlobalNavigationMenu;
